export default function KakaoAds() {
    /* 광고 영역 */
    return (
        <div style={{'textAlign':'center', 'margin': '20px'}}>
          <ins className="kakao_ad_area" style={{ 'display': 'inline-block' }}
            data-ad-unit="DAN-TxD0HdFgmekuvigG"
            data-ad-width="250"
            data-ad-height="250">
          </ins>
        </div>
    );
}